var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.item.editable.geolocationData)?_c('div',{staticClass:"AMapOutLink",on:{"click":_vm.clickOutToMap}},[_c('a-tooltip',{attrs:{"tip":_vm.$t('dict.openMaps'),"discreet":true,"size":"is-small","multilined":false}},[_c('map-icon',{staticClass:"mapPinIconPointer",attrs:{"size":"1.25x"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }